import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { AUTH_URL } from "../../../utils/constants";

const OfficerRegistration = () => {
  const navigate = useNavigate();
  const [officers, setOfficers] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    gender: "",
    email: "",
    password: "",
    mobile: "",
    cag_category: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    gender: "",
    email: "",
    password: "",
    mobile: "",
    cag_category: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  React.useEffect(() => {
    fetchOfficers();
  }, []);

  const fetchOfficers = async () => {
    try {
      const res = await axios.get(`${AUTH_URL.replace('/api/auth/', '/api/')}officers`);
      if (res.data.success) {
        setOfficers(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch officers:", err);
    }
  };

  const validate = () => {
    let isValid = true;
    let newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
      isValid = false;
    }

    // Gender validation
    if (!formData.gender.trim()) {
      newErrors.gender = "Gender is required.";
      isValid = false;
    }

    //Category valodation
    if (!formData.cag_category.trim()) {
      newErrors.cag_category = "Category is required.";
      isValid = false;
    }


    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      newErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    // Password validation
    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
      isValid = false;
    }

    // Mobile validation
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required.";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      // Proceed with form submission
      try {
        let response = await axios.post(
          `${AUTH_URL}officerregister`,
          { ...formData, firstname: formData.name },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response?.status === 201) {
          console.log(response, "line124");
          sessionStorage.setItem("email", response?.data?.email);
          alert("Oficer Registered Successfully.")
          fetchOfficers(); // Refresh the table
          setFormData({
            name: "", gender: "", email: "", password: "", mobile: "", cag_category: ""
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${response?.data?.message}`,
          });
        }
      } catch (error) {
        console.log("Error in registration api", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error in registration api!",
        });
      }
      // navigate("/EmailVerification");
    }
  };

  return (
    // <div className="flex items-center justify-center py-[30px] ">
    //   <div className="w-[90%] border shadow-lg rounded-sm bg-white p-[25px]">
    //     <h1 className="mb-2 text-lg font-bold text-blue">
    //       Registration Details
    //     </h1>
    //     <form onSubmit={handleSubmit}>
    //       <div className="flex flex-wrap justify-between gap-x-3">
    //         {/* Name Field */}
    //         <div className="my-3 w-[47%]">
    //           <label
    //             htmlFor="name"
    //             className="block text-sm font-medium text-gray-700"
    //           >
    //             Name<span className="text-red-500">*</span>
    //           </label>
    //           <input
    //             type="text"
    //             id="name"
    //             value={formData.name}
    //             onChange={handleChange}
    //             className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //               errors.name ? "border-red-500" : "border-gray-300"
    //             } focus:ring-indigo-500 focus:border-indigo-500`}
    //             placeholder="Enter your name"
    //           />
    //           {errors.name && (
    //             <p className="mt-1 text-sm text-red-500">{errors.name}</p>
    //           )}
    //         </div>

    //         {/* Gender Dropdown */}
    //         <div className="my-3 w-[47%]">
    //           <label
    //             htmlFor="gender"
    //             className="block text-sm font-medium text-gray-700"
    //           >
    //             Gender<span className="text-red-500">*</span>
    //           </label>
    //           <select
    //             id="gender"
    //             value={formData.gender}
    //             onChange={handleChange}
    //             className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //               errors.gender ? "border-red-500" : "border-gray-300"
    //             } focus:ring-indigo-500 focus:border-indigo-500`}
    //           >
    //             <option value="">Select Gender</option>
    //             <option value="Male">Male</option>
    //             <option value="Female">Female</option>
    //             <option value="Other">Other</option>
    //           </select>
    //           {errors.gender && (
    //             <p className="mt-1 text-sm text-red-500">{errors.gender}</p>
    //           )}
    //         </div>

    //         {/* Address Field */}
    //         <div className="my-3 w-[47%]">
    //           <label
    //             htmlFor="address"
    //             className="block text-sm font-medium text-gray-700"
    //           >
    //             Address<span className="text-red-500">*</span>
    //           </label>
    //           <input
    //             type="text"
    //             id="address"
    //             value={formData.address}
    //             onChange={handleChange}
    //             className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //               errors.address ? "border-red-500" : "border-gray-300"
    //             } focus:ring-indigo-500 focus:border-indigo-500`}
    //             placeholder="Enter your address"
    //           />
    //           {errors.address && (
    //             <p className="mt-1 text-sm text-red-500">{errors.address}</p>
    //           )}
    //         </div>

    //         {/* Remaining fields (country, state, district, email, mobile) */}
    //         {[
    //           "country",
    //           "state",
    //           "district",
    //           "email",
    //           "password",
    //           "mobile",
    //         ].map((field, index) => (
    //           <div className="my-3 w-[47%]" key={index}>
    //             <label
    //               htmlFor={field}
    //               className="block text-sm font-medium text-gray-700"
    //             >
    //               {field.charAt(0).toUpperCase() + field.slice(1)}
    //               <span className="text-red-500">*</span>
    //             </label>
    //             <input
    //               type={
    //                 field === "email"
    //                   ? "email"
    //                   : field === "mobile"
    //                   ? "number"
    //                   : "text"
    //               }
    //               id={field}
    //               value={formData[field]}
    //               onChange={handleChange}
    //               className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //                 errors[field] ? "border-red-500" : "border-gray-300"
    //               } focus:ring-indigo-500 focus:border-indigo-500`}
    //               placeholder={`Enter your ${field}`}
    //             />
    //             {errors[field] && (
    //               <p className="mt-1 text-sm text-red-500">{errors[field]}</p>
    //             )}
    //           </div>
    //         ))}
    //       </div>
    //       <div className="mt-4 mb-3 flex justify-center">
    //         <button
    //           type="submit"
    //           className="w-[20%] bg-[#251e8a] py-1.5 text-white rounded-md"
    //         >
    //           Submit
    //         </button>
    //       </div>
    //     </form>
    //   </div>
    // </div>
    <div className="h-full w-full flex flex-col items-center px-4 py-6 sm:py-10 overflow-y-auto">
      <div className="w-full max-w-4xl bg-white rounded-xl shadow-md p-6 md:p-10 mb-6">
        <h2 className="text-center text-2xl font-bold text-[#4a0e1e] mb-2">
          Officer Registration
        </h2>
        <p className="text-center text-sm text-gray-600 mb-6">
          Please fill in details to create an officer account
        </p>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { id: "name", label: "Name" },
              { id: "gender", label: "Gender", type: "select" },
              { id: "email", label: "Email", type: "email" },
              { id: "password", label: "Password", type: "password" },
              { id: "mobile", label: "Mobile", type: "tel" },
              { id: "cag_department", label: "Department", type: "department" },
            ].map(({ id, label, type }) => (
              <div key={id}>
                <label
                  htmlFor={id}
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  {label} <span className="text-red-500">*</span>
                </label>

                {type === "department" ? (
                  <select
                    id={id}
                    value={formData[id]}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border ${errors[id] ? "border-red-500" : "border-gray-300"
                      } rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-300`}
                  >
                    <option value="">Select Department</option>
                    <option value="Ministry of Women and Child Development">Ministry of Women and Child Development</option>
                    <option value="Complaint & Investigation Cell">Complaint & Investigation Cell</option>
                  </select>
                ) :
                  type === "select" ? (
                    <select
                      id={id}
                      value={formData[id]}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border ${errors[id] ? "border-red-500" : "border-gray-300"
                        } rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-300`}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  ) : (
                    <input
                      id={id}
                      type={type || "text"}
                      placeholder={`Enter your ${label.toLowerCase()}`}
                      value={formData[id]}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border ${errors[id] ? "border-red-500" : "border-gray-300"
                        } rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-green-300`}
                    />
                  )}

                {errors[id] && (
                  <p className="text-sm text-red-500 mt-1">{errors[id]}</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
            <button
              type="button"
              onClick={() => navigate("/adminDesk")}
              className="w-full sm:w-1/2 bg-gray-500 text-white py-2.5 rounded-md shadow hover:bg-gray-600 transition font-medium cursor-pointer"
            >
              Back to Dashboard
            </button>
            <button
              type="submit"
              className="w-full sm:w-1/2 bg-[#4a0e1e] hover:bg-[#9c2942] text-white py-2.5 rounded-md shadow-md transition-all duration-200 hover:scale-[1.02] font-bold cursor-pointer"
            >
              Register Officer
            </button>
          </div>

          {/* <div className="mt-4 text-center text-sm">
            <span
              className="text-saffron hover:underline cursor-pointer"
              onClick={() => navigate("/login")}
            >
              Already have an account? Sign In
            </span>
          </div> */}
        </form>
      </div>

      <div className="w-full max-w-4xl bg-white rounded-xl shadow-md p-6 md:p-8">
        <h3 className="text-xl font-bold text-[#0e2f4d] mb-4">Registered Officers</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-600">
            <thead className="text-xs uppercase bg-gray-50 text-gray-700 font-semibold border-b">
              <tr>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Email / Login</th>
                <th className="px-4 py-3">Department</th>
                <th className="px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {officers.map((officer, idx) => (
                <tr key={idx} className="border-b hover:bg-gray-50 transition">
                  <td className="px-4 py-3">{officer.firstname || officer.name}</td>
                  <td className="px-4 py-3">{officer.email}</td>
                  <td className="px-4 py-3">{officer.cag_category}</td>
                  <td className="px-4 py-3">
                    <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-xs font-semibold">Active</span>
                  </td>
                </tr>
              ))}
              {officers.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center px-4 py-4 text-gray-500">No registered officers found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OfficerRegistration;
